import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import strings from 'amdi18n-loader!@/nls/promote_deployment';
import template from '@/../templates/dialog-promote-code.hbs';
import Api from '@/lib/api/api';

    var globalCh = Radio.channel('global');

    var MAX_DESCRIPTION_LENGTH = 300;

    var PromoteCodeDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        initialize: function(options) {
            this.destroyOnClose();
            this.focusFirstInput();
        },
        ui: {
            alert: '.modal-alert-container > .alert',
            alert_container: '.modal-alert-container',
            description: '.promotion-description',
            submit_btn: 'button[type="submit"]',
            description_length_counter: '.max-description-length'
        },
        events: {
            'change @ui.description': 'validate_description',
            'keyup @ui.description': 'validate_description',
            'paste @ui.description': 'validate_description',
            'mouseup @ui.description': 'validate_description',
            'submit form': 'on_submit'
        },
        templateOptions: { data : { intl : strings } },
        templateContext: function(){
            return { max_char: MAX_DESCRIPTION_LENGTH };
        },
        validate_description: function(e) {
            this.check_validation(
                $(e.target),
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter,
                this.ui.submit_btn);
        },
        on_submit: function(e) {
            e.preventDefault();
            this.hideAlert();

            this.model.save({
                data: {
                    id: this.model.id,
                    type: this.model.type,
                    attributes: {
                        flagged: true,
                        description: this.ui.description.val().trim()                        
                    }
                }
            }, {
                url: Api.urls.deployment_nocode({ id: this.model.id, nocode: true }),
                patch: true,
                wait: true,
                success: _.bind(this.on_success, this),
                error: _.bind(this.on_error, this)
            });

        },
        on_success: function() {
            this.closeDialog();
            var message = strings.deploy_success_message;
            this.options.success();
            globalCh.request('layout_alert', message, 'success', 4000);
        },
        on_error: function(deployment, response) {
            var message = 'There was an error processing your request';
            if ( response && response.responseJSON && response.responseJSON.errors && response.responseJSON.errors.length > 0) {
                message = '';
                _.each( response.responseJSON.errors, function(err){
                    message = message + err.title + ': ' + err.detail + '<br>';
                });
            }
            this.showAlert('error', message);
        }
    });
    export default PromoteCodeDialog;

